export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.themeToggle.switchToLight': '切换到亮色模式',
  'component.themeToggle.switchToDark': '切换到深色模式',
};
